import React from "react";
import moment from "moment";
import { Box, Typography, Button, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import { formatRate, getSportsIcon, getTeamLogoSrc } from "../constants";

const Event = ({ event, showLeague, onLeagueClick }) => {
  const localDate = moment(event.datetime).local().format("h:mm a");
  const navigate = useNavigate();

  const handleShowOdds = () => {
    navigate(`event/${event.eventId}`);
  };

  const handleShowSGM = (e) => {
    e.stopPropagation(); // Prevent event click from triggering
    navigate(`/sgm/${event.eventId}`);
  };

  const isPro = window.membershipLevel === 30;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 2,
        "&:not(:first-of-type)": {
          borderTop: "1px solid #f0f0f0",
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subTitle1">{event.team1}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="subTitle1">{event.team2}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: { xs: "0", sm: "8px" },
            alignItems: { xs: "flex-start", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {localDate}
          </Typography>
          <Button
            variant="text"
            onClick={handleShowOdds}
            sx={{
              textTransform: "none",
              whiteSpace: "nowrap",
              flexShrink: 0,
              color: "#35BD5B",
              p: 0,
              backgroundColor: "transparent",
              "&:hover": {
                textDecoration: "underline",
                backgroundColor: "transparent",
              },
            }}
            endIcon={
              <ArrowForwardIosIcon
                sx={{
                  height: { xs: "8px", sm: "12px" },
                  width: { xs: "8px", sm: "12px" },
                }}
              />
            }
          >
            Compare Odds
          </Button>
          {isPro && (
            <Button
              variant="contained"
              size="small"
              onClick={handleShowSGM}
              sx={{
                textTransform: "none",
                whiteSpace: "nowrap",
                flexShrink: 0,
                color: "white",
                backgroundColor: "#FF9800",
                borderRadius: "12px",
                p: "2px 8px",
                height: "24px",
                fontSize: "12px",
                minWidth: "unset",
                boxShadow: 1,
                transition: "all 0.2s",
                "&:hover": {
                  backgroundColor: "#F57C00",
                  transform: "translateY(-1px)",
                  boxShadow: 2,
                },
              }}
              startIcon={
                <ConstructionRoundedIcon
                  sx={{
                    fontSize: "14px",
                    mr: "2-4px",
                  }}
                />
              }
            >
              SGM
            </Button>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: { xs: "150px", sm: "240px" },
          justifyContent: "flex-end",
        }}
      >
        {showLeague ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              minWidth: { xs: "50px", sm: "80px" },
            }}
          >
            <Typography
              variant="subTitle1"
              sx={{
                padding: { xs: "4px", sm: "8px" },
                borderRadius: "4px",
                minWidth: { xs: "40px", sm: "70px" },
                fontWeight: 600,
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: (theme) => theme.palette.eventBackground.main,
                cursor: "pointer",
              }}
              onClick={() => onLeagueClick(event.league)}
            >
              {getSportsIcon(event.sport)}

              {event.league}
            </Typography>
          </Box>
        ) : (
          <>
            {event?.outcomes
              ?.filter((outcome) => outcome.order > 0)
              ?.sort((a, b) => a.order - b.order)
              ?.map((outcome) => (
                <Box
                  key={outcome.order}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: { xs: "0px", sm: "80px" },
                  }}
                >
                  <Typography
                    variant="subTitle1"
                    sx={{
                      padding: { xs: "4px", sm: "8px" },
                      borderRadius: "4px",
                      width: { xs: "40px", sm: "70px" },
                      textAlign: "center",
                      backgroundColor: (theme) =>
                        theme.palette.eventBackground.main,
                    }}
                  >
                    {formatRate(outcome.bestOdds)}
                  </Typography>
                </Box>
              ))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Event;
